import { apiPaths } from '../config/apiPaths';
import { postJson } from '../postClient';

export const getTemplatesApi = (inputData, authHeaders) =>
  postJson(apiPaths.whatsappChannel, inputData, authHeaders, {
    defaultError: 'Failed to fetch templates',
  });
